module.exports = __webpack_public_path__ + "img/group1.b31f6a09.png";